import { render, staticRenderFns } from "./FaturaForm.vue?vue&type=template&id=1a36073c&"
import script from "./FaturaForm.vue?vue&type=script&lang=js&"
export * from "./FaturaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports